












































import {defineComponent} from '@vue/composition-api'
import {useGetters, useMutations, useState} from 'vuex-composition-helpers'

import linkDirective from '@/shared/directives/link-directive'

import breakpointService from '@/shared/services/breakpoint-service'

import {Breakpoint} from '@/shared/models/breakpoint-type'

import IconLinkAtom from '@/shared/components/atoms/IconLinkAtom.vue'
import ImageRatioMolecule from '@/shared/components/molecules/ImageRatioMolecule.vue'
import IntroComponent from '../shared/IntroComponent.vue'
import HeadingAtom from '@/shared/components/atoms/HeadingAtom.vue'
import NavigationComponent from '../shared/NavigationComponent.vue'
import {ISlide} from '../../models/slide'

export default defineComponent({
  name: 'MultipleSlider',
  components: {
    IconLinkAtom,
    ImageRatioMolecule,
    IntroComponent,
    HeadingAtom,
    NavigationComponent
  },
  directives: {
    linkDirective
  },
  methods: {
    containsLink(slide: ISlide): Boolean {
      return Boolean(slide?.link?.trim())
    }
  },
  setup: () => {
    const {currentIndex, transition} = useState(['currentIndex', 'transition'])
    const {setSlidesPerView} = useMutations(['setSlidesPerView'])
    const {showNavigation, multipleSlides, imageFallback} = useGetters(['showNavigation', 'multipleSlides', 'imageFallback'])

    function slidesPerView(): number {
      const breakpoint: Breakpoint = breakpointService.currentBreakpoint

      switch (breakpoint) {
        case Breakpoint.Mobile:
          return 1
        case Breakpoint.TabletPortrait:
        case Breakpoint.TabletLandscape:
          return 2
        default:
          return 3
      }
    }

    setSlidesPerView(slidesPerView())

    return {
      currentIndex,
      transition,
      showNavigation,
      multipleSlides,
      imageFallback
    }
  }
})
